import { cn } from '@/lib/utils'

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'accent' | 'secondary' | 'outline'
  size?: 'sm' | 'md' | 'lg'
  fullWidth?: boolean
}

export function PrimaryButton({ 
  children, 
  className, 
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled,
  ...props 
}: PrimaryButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-medium rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--pd-ring)] disabled:opacity-50 disabled:cursor-not-allowed'
  
  const variantStyles = {
    primary: 'bg-[#0B2A4A] dark:bg-[#1e40af] hover:bg-[#123A63] dark:hover:bg-[#1e3a8a] text-white shadow-lg hover:shadow-xl font-semibold',
    accent: 'bg-[#F08A24] hover:bg-[#e07a14] text-white dark:text-[#0b2a4a] shadow-lg hover:shadow-xl font-semibold',
    secondary: 'bg-[#f7f7f8] dark:bg-[#1e293b] hover:bg-[#e5e5e7] dark:hover:bg-[#334155] text-[#0B2A4A] dark:text-[#e8eef6] border border-[#0B2A4A]/20 dark:border-[#e8eef6]/20 font-semibold',
    outline: 'bg-white dark:bg-[#0f172a] border-2 border-[#0B2A4A] dark:border-[#F08A24] hover:bg-[#F6EBDD] dark:hover:bg-[#F08A24]/10 text-[#0B2A4A] dark:text-[#F08A24] shadow-md hover:shadow-lg font-semibold'
  }
  
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  }

  return (
    <button
      {...props}
      disabled={disabled}
      className={cn(
        baseStyles,
        variantStyles[variant],
        sizeStyles[size],
        fullWidth && 'w-full',
        className
      )}
    >
      {children}
    </button>
  )
}
